import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Button from "../../../components/button";
import CardContainer from "../../../components/card_container";
import LoadingModal from "../../../components/loading_modal";
import {
    FiUser,
    FiMail,
    FiPhone,
    FiLock,
    FiBarChart2,
    FiFolder,
    FiPackage,
    FiUsers,
    FiShoppingCart,
    FiSettings,
    FiEdit2,
    FiCalendar,
    FiCheckCircle,
    FiXCircle
} from "react-icons/fi";
import { FaRegIdCard } from "react-icons/fa";
import { EDITADMINISTRATOR } from "../../../routes/routes_name";
import "./detailAdminStyle.scss";
import { axios, errorResponse } from "../../../helpers";
import { useSelector } from "react-redux";
import { loginData } from "../../../stores/auth";

const DetailAdministratorPage = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [administratorData, setAdministratorData] = useState(null);
    const [activeTab, setActiveTab] = useState('info');
    const dataLogin = useSelector(loginData);

    // Fetch data
    useEffect(() => {
        fetchAdministratorData();
    }, [id]);

    const fetchAdministratorData = async () => {
        setIsLoading(true);
        try {
            // Use real API endpoint to fetch administrator data by ID
            const response = await axios.get(`/v1/user/superadmin/${id}`, {
                headers: {
                    Authorization: `Bearer ${dataLogin?.data?.token ?? ''}`
                }
            });
            const adminData = response.data.data;

            setTimeout(() => {
                setAdministratorData(adminData);
                setIsLoading(false);
            }, 800);
        } catch (error) {
            console.error("Error fetching administrator data:", error);
            console.error("Error details:", errorResponse(error));
            setIsLoading(false);
        }
    };

    const handleEdit = () => {
        navigate(EDITADMINISTRATOR, {
            state: {
                ...administratorData,
                _id: administratorData?._id || administratorData?.id || id,
            },
        });
    };

    const handleBack = () => {
        navigate(-1);
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('id-ID', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    if (isLoading) {
        return <LoadingModal isLoading={true} />;
    }

    if (!administratorData) {
        return (
            <CardContainer
                title="Administrator Not Found"
                isBack={true}
                children={
                    <div className="not-found-container">
                        <p>Administrator data not found.</p>
                        <Button
                            title="Back to List"
                            onClick={handleBack}
                            variant="outline"
                        />
                    </div>
                }
            />
        );
    }

    return (
        <>
            <CardContainer
                title={
                    <div className="detail-header">
                        <div className="header-main">
                            <div className="header-icon-wrapper">
                                <FiUser className="header-icon" />
                            </div>
                            <div>
                                <h1 className="page-title">Administrator Details</h1>
                                <div className="header-subtitle">
                                    <span className="admin-name">{administratorData.name}</span>
                                    <span className={`status-badge ${administratorData.status}`}>
                                        {administratorData.status === 'aktif' ? 'Aktif' : 'Tidak Aktif'}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                isBack={true}
                children={(
                    <div className="detail-container" style={{ height: "70vh" }}>
                        {/* Tabs Navigation */}
                        <div className="detail-tabs">
                            <button
                                className={`tab-button ${activeTab === 'info' ? 'active' : ''}`}
                                onClick={() => setActiveTab('info')}
                            >
                                <FaRegIdCard className="tab-icon" />
                                <span>Account Information</span>
                            </button>
                            <button
                                className={`tab-button ${activeTab === 'permissions' ? 'active' : ''}`}
                                onClick={() => setActiveTab('permissions')}
                            >
                                <FiSettings className="tab-icon" />
                                <span>Permissions</span>
                            </button>
                            {/* <button
                                className={`tab-button ${activeTab === 'activity' ? 'active' : ''}`}
                                onClick={() => setActiveTab('activity')}
                            >
                                <FiCalendar className="tab-icon" />
                                <span>Activity</span>
                            </button> */}
                        </div>

                        {/* Tab Content */}
                        <div className="tab-content">
                            {activeTab === 'info' && (
                                <div className="info-section">
                                    <div className="section-card">
                                        <h3 className="section-title">
                                            <FiUser className="section-icon" />
                                            Personal Information
                                        </h3>
                                        <div className="info-grid">
                                            <div className="info-field">
                                                <label className="field-label">
                                                    <FiUser className="field-icon" />
                                                    Full Name
                                                </label>
                                                <div className="field-value">
                                                    {administratorData.name}
                                                </div>
                                            </div>
                                            <div className="info-field">
                                                <label className="field-label">
                                                    <FiMail className="field-icon" />
                                                    Email Address
                                                </label>
                                                <div className="field-value">
                                                    {administratorData.email}
                                                </div>
                                            </div>
                                            <div className="info-field">
                                                <label className="field-label">
                                                    <FiPhone className="field-icon" />
                                                    Phone Number
                                                </label>
                                                <div className="field-value">
                                                    {administratorData.phone_number}
                                                </div>
                                            </div>
                                            <div className="info-field">
                                                <label className="field-label">
                                                    <FiLock className="field-icon" />
                                                    Account Status
                                                </label>
                                                <div className="field-value">
                                                    <span className={`status-text ${administratorData.status}`}>
                                                        {administratorData.status === 'aktif' ? 'Aktif' : 'Tidak Aktif'}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="section-card">
                                        <h3 className="section-title">
                                            <FiCalendar className="section-icon" />
                                            Account
                                        </h3>
                                        <div className="timeline-grid">
                                            <div className="timeline-item">
                                                <label className="timeline-label">Created At</label>
                                                <div className="timeline-value">
                                                    <FiCalendar className="timeline-icon" />
                                                    {formatDate(administratorData.createdAt)}
                                                </div>
                                            </div>
                                            <div className="timeline-item">
                                                <label className="timeline-label">Last Updated</label>
                                                <div className="timeline-value">
                                                    <FiCalendar className="timeline-icon" />
                                                    {formatDate(administratorData.updatedAt)}
                                                </div>
                                            </div>
                                            {/* <div className="timeline-item">
                                                <label className="timeline-label">Last Login</label>
                                                <div className="timeline-value">
                                                    <FiCalendar className="timeline-icon" />
                                                    {administratorData.last_login ? formatDate(administratorData.last_login) : 'Never logged in'}
                                                </div>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            )}

                            {activeTab === 'permissions' && (
                                <div className="permissions-section">
                                    <div className="section-card">
                                        <h3 className="section-title">
                                            <FiSettings className="section-icon" />
                                            Feature Access Permissions
                                        </h3>

                                        {/* Quick Access Summary */}
                                        <div className="permissions-summary">
                                            <div className="summary-card">
                                                <div className="summary-header">
                                                    <h4>Access Summary</h4>
                                                </div>
                                                <div className="summary-stats">
                                                    <div className="stat-item">
                                                        <span className="stat-label">Total Features</span>
                                                        <span className="stat-value">10</span>
                                                    </div>
                                                    <div className="stat-item">
                                                        <span className="stat-label">Granted</span>
                                                        <span className="stat-value granted">7</span>
                                                    </div>
                                                    <div className="stat-item">
                                                        <span className="stat-label">Restricted</span>
                                                        <span className="stat-value restricted">3</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Permissions List */}
                                        <div className="permissions-list">
                                            <div className="permission-category">
                                                <h4 className="category-title">Dashboard</h4>
                                                <div className="permission-item">
                                                    <div className="permission-info">
                                                        <FiBarChart2 className="permission-icon" />
                                                        <span className="permission-name">Dashboard Access</span>
                                                    </div>
                                                    <div className="permission-status">
                                                        {administratorData.features_access_user.dashboard ? (
                                                            <div className="status-granted">
                                                                <FiCheckCircle className="status-icon" />
                                                                <span>Granted</span>
                                                            </div>
                                                        ) : (
                                                            <div className="status-restricted">
                                                                <FiXCircle className="status-icon" />
                                                                <span>Restricted</span>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="permission-category">
                                                <h4 className="category-title">Inventory Management</h4>
                                                <div className="permission-item">
                                                    <div className="permission-info">
                                                        <FiFolder className="permission-icon" />
                                                        <span className="permission-name">Fabrics</span>
                                                    </div>
                                                    <div className="permission-status">
                                                        {administratorData.features_access_user.fabrics ? (
                                                            <div className="status-granted">
                                                                <FiCheckCircle className="status-icon" />
                                                                <span>Granted</span>
                                                            </div>
                                                        ) : (
                                                            <div className="status-restricted">
                                                                <FiXCircle className="status-icon" />
                                                                <span>Restricted</span>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="permission-item">
                                                    <div className="permission-info">
                                                        <FiPackage className="permission-icon" />
                                                        <span className="permission-name">Style Accents</span>
                                                    </div>
                                                    <div className="permission-status">
                                                        {administratorData.features_access_user.style_accents ? (
                                                            <div className="status-granted">
                                                                <FiCheckCircle className="status-icon" />
                                                                <span>Granted</span>
                                                            </div>
                                                        ) : (
                                                            <div className="status-restricted">
                                                                <FiXCircle className="status-icon" />
                                                                <span>Restricted</span>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="permission-category">
                                                <h4 className="category-title">Reports</h4>
                                                <div className="permission-item">
                                                    <div className="permission-info">
                                                        <FiBarChart2 className="permission-icon" />
                                                        <span className="permission-name">Report Access</span>
                                                    </div>
                                                    <div className="permission-status">
                                                        {administratorData.features_access_user.report ? (
                                                            <div className="status-granted">
                                                                <FiCheckCircle className="status-icon" />
                                                                <span>Granted</span>
                                                            </div>
                                                        ) : (
                                                            <div className="status-restricted">
                                                                <FiXCircle className="status-icon" />
                                                                <span>Restricted</span>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="permission-category">
                                                <h4 className="category-title">Master Data</h4>
                                                <div className="permission-item">
                                                    <div className="permission-info">
                                                        <FiUsers className="permission-icon" />
                                                        <span className="permission-name">Administrator Management</span>
                                                    </div>
                                                    <div className="permission-status">
                                                        {administratorData.features_access_user.master?.administrator ? (
                                                            <div className="status-granted">
                                                                <FiCheckCircle className="status-icon" />
                                                                <span>Granted</span>
                                                            </div>
                                                        ) : (
                                                            <div className="status-restricted">
                                                                <FiXCircle className="status-icon" />
                                                                <span>Restricted</span>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="permission-item">
                                                    <div className="permission-info">
                                                        <FiUsers className="permission-icon" />
                                                        <span className="permission-name">User Management</span>
                                                    </div>
                                                    <div className="permission-status">
                                                        {administratorData.features_access_user.master?.user ? (
                                                            <div className="status-granted">
                                                                <FiCheckCircle className="status-icon" />
                                                                <span>Granted</span>
                                                            </div>
                                                        ) : (
                                                            <div className="status-restricted">
                                                                <FiXCircle className="status-icon" />
                                                                <span>Restricted</span>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="permission-item">
                                                    <div className="permission-info">
                                                        <FiFolder className="permission-icon" />
                                                        <span className="permission-name">Product Category</span>
                                                    </div>
                                                    <div className="permission-status">
                                                        {administratorData.features_access_user.master?.product_category ? (
                                                            <div className="status-granted">
                                                                <FiCheckCircle className="status-icon" />
                                                                <span>Granted</span>
                                                            </div>
                                                        ) : (
                                                            <div className="status-restricted">
                                                                <FiXCircle className="status-icon" />
                                                                <span>Restricted</span>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="permission-item">
                                                    <div className="permission-info">
                                                        <FiPackage className="permission-icon" />
                                                        <span className="permission-name">Product List</span>
                                                    </div>
                                                    <div className="permission-status">
                                                        {administratorData.features_access_user.master?.product_list ? (
                                                            <div className="status-granted">
                                                                <FiCheckCircle className="status-icon" />
                                                                <span>Granted</span>
                                                            </div>
                                                        ) : (
                                                            <div className="status-restricted">
                                                                <FiXCircle className="status-icon" />
                                                                <span>Restricted</span>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="permission-category">
                                                <h4 className="category-title">Transactions</h4>
                                                <div className="permission-item">
                                                    <div className="permission-info">
                                                        <FiShoppingCart className="permission-icon" />
                                                        <span className="permission-name">Transaction Access</span>
                                                    </div>
                                                    <div className="permission-status">
                                                        {administratorData.features_access_user.transactions ? (
                                                            <div className="status-granted">
                                                                <FiCheckCircle className="status-icon" />
                                                                <span>Granted</span>
                                                            </div>
                                                        ) : (
                                                            <div className="status-restricted">
                                                                <FiXCircle className="status-icon" />
                                                                <span>Restricted</span>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="permission-category">
                                                <h4 className="category-title">System</h4>
                                                <div className="permission-item">
                                                    <div className="permission-info">
                                                        <FiSettings className="permission-icon" />
                                                        <span className="permission-name">Settings Access</span>
                                                    </div>
                                                    <div className="permission-status">
                                                        {administratorData.features_access_user.settings ? (
                                                            <div className="status-granted">
                                                                <FiCheckCircle className="status-icon" />
                                                                <span>Granted</span>
                                                            </div>
                                                        ) : (
                                                            <div className="status-restricted">
                                                                <FiXCircle className="status-icon" />
                                                                <span>Restricted</span>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {activeTab === 'activity' && (
                                <div className="activity-section">
                                    <div className="section-card">
                                        <h3 className="section-title">
                                            <FiCalendar className="section-icon" />
                                            Recent Activity
                                        </h3>
                                        <div className="activity-list">
                                            <div className="activity-item">
                                                <div className="activity-icon success">
                                                    <FiCheckCircle />
                                                </div>
                                                <div className="activity-content">
                                                    <p className="activity-title">Logged in to system</p>
                                                    <p className="activity-time">Today, 09:15 AM</p>
                                                </div>
                                            </div>
                                            <div className="activity-item">
                                                <div className="activity-icon info">
                                                    <FiEdit2 />
                                                </div>
                                                <div className="activity-content">
                                                    <p className="activity-title">Updated user permissions</p>
                                                    <p className="activity-time">Yesterday, 14:30 PM</p>
                                                </div>
                                            </div>
                                            <div className="activity-item">
                                                <div className="activity-icon warning">
                                                    <FiLock />
                                                </div>
                                                <div className="activity-content">
                                                    <p className="activity-title">Password changed</p>
                                                    <p className="activity-time">3 days ago, 11:20 AM</p>
                                                </div>
                                            </div>
                                            <div className="activity-item">
                                                <div className="activity-icon">
                                                    <FiUser />
                                                </div>
                                                <div className="activity-content">
                                                    <p className="activity-title">Profile information updated</p>
                                                    <p className="activity-time">Jan 20, 2024, 14:45 PM</p>
                                                </div>
                                            </div>
                                            <div className="activity-item">
                                                <div className="activity-icon">
                                                    <FiCalendar />
                                                </div>
                                                <div className="activity-content">
                                                    <p className="activity-title">Account created</p>
                                                    <p className="activity-time">Jan 15, 2024, 10:30 AM</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Action Buttons */}
                        <div className="detail-actions">
                            <div className="action-buttons">
                                <Button
                                    type="button"
                                    variant="outline"
                                    className="btn-outline-secondary"
                                    title="Back to List"
                                    onClick={handleBack}
                                />
                                <div className="action-group">
                                    <Button
                                        type="button"
                                        variant="primary"
                                        className="btn-primary"
                                        title="Edit"
                                        onClick={handleEdit}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            />
            <LoadingModal isLoading={isLoading} />
        </>
    );
};

export default DetailAdministratorPage;